import { PartnerUser } from './partner-user';
import { SelectItem } from '../../promotions/select-item';

export class UsersSearchDto{
  allPartnerUsers : PartnerUser[] ;
  updatedUsers : PartnerUser[] ;

  registrationId : string ;
  userStatus : string ;
  firstName : string ;
  lastName : string ;
  emailAddress : string ;
  areaCode : string ;
  phoneNumber : string ;
  phoneExt : string ;
  salesOfficeId : string ;
  partnerId : number ;
  isNewUser : boolean ;
  editUser : boolean ;
  searched : boolean ;
  isAdmin : boolean ;
  accountAccessLevel:SelectItem[]
  salesOfficesMap : Map<number, string> ;
  statusItems :  SelectItem[]  ;
  officeItems : SelectItem[] ;
  selectedUser : PartnerUser ;
  partnerDto: PartnerUser ;
}

